import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "./components/ui/AppLayout";
import Home from "./pages/Home";
import PageNotFound from "./pages/PageNotFound";
import Login from "./pages/Login";
import Register from "./pages/Register";
import WeightDiscrepancies from "./pages/WeightDiscrepancies";
import RateCalculator from "./pages/RateCalculator";
import RateCard from "./pages/RateCard";
import SupportWeb from "./pages/SupportWeb";
import Ticket from "./pages/Ticket";
import Returns from "./pages/Returns";
import AddReturns from "./components/features/returns/AddReturns";
import Order from "./pages/Order";
import AddOrder from "./components/features/orders/AddOrder";
import CommonRoute from "./components/ui/CommonRoute";
import Settings from "./components/features/settings/Settings";
import ManagePickupAddress from "./components/features/settings/ManagePickupAddress";
import CompanyProfile from "./components/features/settings/CompanyProfile";
import Kyc from "./components/features/settings/Kyc";
import OrderDetails from "./components/features/orders/OrderDetails";
import ReturnsDetail from "./components/features/returns/ReturnsDetail";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ui/ProtectedRoute";
import ChangePassword from "./components/features/settings/ChangePassword";
import Customer from "./components/features/setUp/Customer";
import ForgotPassword from "./components/features/auth/ForgotPassword";
import Services from "./components/features/setUp/Services";
import CustomerDetails from "./components/features/setUp/CustomerDetails";
import DrawerProvider from "./provider/DrawerProvider";
import ModalProvider from "./provider/ModalProvider";
import { Toaster } from "react-hot-toast";
import TrackShipment from "./pages/TrackShipment";
import ShipmentProfiles from "./components/features/setUp/ShipmentProfiles";
import LandingPage from "./pages/LandingPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import BillingAddress from "./pages/BillingAddress";
import GstInvoice from "./pages/GstInvoice";
import Reports from "./components/features/tools/Reports";
import BulkPrintActions from "./components/features/tools/BulkPrintActions";
import Billing from "./pages/Billing";
import UserRoleManagement from "./components/features/settings/UserRoleManagement";
import UserRoleEdit from "./components/features/settings/UserRoleEdit";
import UserRoleAdd from "./components/features/settings/UserRoleAdd";
import TrackShipmentAwb from "./pages/TrackShipmentAwb";
import TrackShipmentOrder from "./pages/TrackShipmentOrder";
import MISReports from "./components/features/tools/MISReports";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 60 * 1000,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <DrawerProvider />
          <ModalProvider />
          <Routes>
            <Route path="tracking-shipment-order/:order_id" element={<TrackShipmentOrder />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate replace to="dashboard" />} />
              <Route path="home" element={<Home />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="tracking/:order_id" element={<TrackShipment />} />
              <Route path="tracking-shipment/:order_id" element={<TrackShipmentAwb />} />
              <Route path="tracking-shipment-order/:order_id" element={<TrackShipmentOrder />} />

              <Route path="returns" element={<CommonRoute />}>
                <Route path="" element={<Returns />} />
                <Route path="add-returns" element={<AddReturns />} />
                <Route path="edit-returns" element={<AddReturns />} />
                <Route path="details/:slug" element={<ReturnsDetail />} />
              </Route>
              <Route path="order" element={<CommonRoute />}>
                <Route path="" element={<Order />} />
                <Route path="add-order" element={<AddOrder />} />
                <Route path="details/:order_id" element={<OrderDetails />} />
              </Route>
              <Route path="tools" element={<CommonRoute />}>
                <Route path="reports" element={<Reports />} />
                <Route path="mis-report" element={<MISReports />} />
                <Route path="bulk-action" element={<BulkPrintActions />} />
              </Route>
              <Route path="set-up-and-management" element={<CommonRoute />}>
                <Route path="customer_search" element={<Customer />} />
                <Route
                  path="shipment_profiles"
                  element={<ShipmentProfiles />}
                />
                <Route
                  path="customer_search/:mobileNumber"
                  element={<CustomerDetails />}
                />
                <Route path="all_service" element={<Services />} />
              </Route>
              <Route path="support-and-help" element={<CommonRoute />}>
                <Route path="" element={<SupportWeb />} />
                <Route path="ticket" element={<Ticket />} />
              </Route>

              <Route path="weight-and-managements" element={<CommonRoute />}>
                <Route
                  path="weight-and-discrepancies"
                  element={<WeightDiscrepancies />}
                />
              </Route>
              <Route
                path="tools/rate-calculator"
                element={<RateCalculator />}
              />
              <Route path="tools/rate-card" element={<RateCard />} />
              <Route path="settings" element={<CommonRoute />}>
                <Route path="" element={<Settings />} />
                <Route path="change-password" element={<ChangePassword />} />

                <Route path="kyc" element={<Kyc />} />
                <Route
                  path="manage-pickup-addresses"
                  element={<ManagePickupAddress />}
                />
                <Route path="company-profile" element={<CompanyProfile />} />
                <Route path="billing_invoicing" element={<BillingAddress />} />
                <Route path="gstin_invoicing" element={<GstInvoice />} />
                <Route
                  path="user-role-management"
                  element={<UserRoleManagement />}
                />
                <Route
                  path="user-role-management/add"
                  element={<UserRoleAdd />}
                />
                <Route
                  path="user-role-management/:user_id"
                  element={<UserRoleEdit />}
                />
                {/* <Route path="returns" element={<CommonRoute />}>
                <Route path="" element={<RefundSettings />} />
              </Route> */}
              </Route>
              <Route path="billing" element={<Billing />} />
            </Route>
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />

            <Route path="hipship" element={<LandingPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          gutter={12}
          containerStyle={{ margin: "8px" }}
          toastOptions={{
            success: {
              duration: 2000,
            },
            error: {
              duration: 2000,
            },
            style: {
              fontSize: "16px",
              maxWidth: "500px",
              padding: "16px 24px",
              backgroundColor: "#27374d",
              color: "#fff",
            },
          }}
        />
      </QueryClientProvider>
    </>
  );
};

export default App;
